









import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import marked, {MarkedOptions} from 'marked';
import DOMPurify from 'dompurify';

@Component({
  name: 'DisplayMarkup',
})
export default class DisplayMarkup extends Vue {
  @Prop({type: String, default: null}) readonly text!: string;

  private marked = marked;
  private markedOptions: MarkedOptions = {
    breaks: true,
    sanitizer: this.sanitizer,
  };

  private sanitizer(text: string): string {
    return DOMPurify.sanitize(text);
  }
}
